import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { setSelectedRow, onUpdateColumn, setOrder, setPage, setPageSize } from '../../store/roles/actions';
import { sort_by } from '../../helpers/commons';

import { FieldSet, Table } from '@sigeco/tools';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    root: {
        display: 'flex',
        flex: '1 1 auto',
        flexDirection: 'column',
    },
    tableWrap: {
        flex: '1 1 auto',
    },
}));

const RolList = () => {
    const history = useHistory();
    const location = useLocation();
    const classes = useStyles();
    const columns = useSelector((state) => state.roles.table.columns);
    const loading = useSelector((state) => state.roles.store.loading);
    const order = useSelector((state) => state.roles.table.order);
    const orderBy = useSelector((state) => state.roles.table.orderBy);
    const store = useSelector((state) => state.roles.store);
    const dispatch = useDispatch();

    const handleDoubleClick = (id) => {
        history.push({
            hash: location.hash,
            pathname: `/roles/${id}`,
            search: location.search,
        });
    };

    const handleRequestSort = (property) => {
        const isAsc = orderBy === property && order === 'asc';
        dispatch(setOrder(isAsc ? 'desc' : 'asc', property));
        let data = store.data;
        data.sort(sort_by(property, isAsc, data[0][property]));
    };

    return (
        <FieldSet className={classes.root} iconCls="fas fa-th-list" title="Resultados">
            <div className={classes.tableWrap}>
                <Table
                    columns={columns}
                    count={store.total}
                    loading={loading}
                    onRowClick={(items) => dispatch(setSelectedRow(items))}
                    onRowDoubleClick={(item) => handleDoubleClick(item.rolId)}
                    onSort={(datakey) => handleRequestSort(datakey)}
                    onUpdateColumn={onUpdateColumn}
                    page={store.start / store.pageSize}
                    paginate
                    rowCount={store.data.length}
                    rowGetter={(index) => store.data[index]}
                    rowsPerPage={store.pageSize}
                    selected={store.selected}
                    sortBy={orderBy}
                    sortDirection={order}
                />
            </div>
        </FieldSet>
    );
};

export default RolList;
